import React from 'react';
import { Stack, Typography } from '@mui/material';
import { QuestionExpectedAnswer } from 'generated-graphql/types';

type KnockOutQuestionViewProps = {
  content: string;
  expectedAnswer: QuestionExpectedAnswer | null;
};

export const KnockOutQuestionView: React.FC<KnockOutQuestionViewProps> = ({
  content,
  expectedAnswer
}) => {
  const displayExpectedAnswer = expectedAnswer || QuestionExpectedAnswer.IsYes;

  return (
    <Stack gap="10px" flex="1">
      <Typography variant="captions">Knockout question</Typography>
      <Typography variant="summary">{content}</Typography>
      <Typography>
        The candidate must answer "
        {displayExpectedAnswer === QuestionExpectedAnswer.IsYes ? 'yes' : 'no'}"
        to progress.
      </Typography>
    </Stack>
  );
};
